import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions'
import AccountList from "./AccountList";

class AccountsListPage extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render () {
    return(
      <div className="genericPageContainer grey">
        <div className="genericTitleBar">My Accounts</div>
        <div className="genericPageWrap titleBar grey">
          <AccountList accounts={this.props.accounts}/>
        </div>
      </div>
    );
  }
}

AccountsListPage.propTypes = {
  actions: PropTypes.object.isRequired,
  accounts: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    accounts: state.accounts
  }
}

function matchDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps,matchDispatchToProps)(AccountsListPage);




// WEBPACK FOOTER //
// ./src/components/account/AccountsListPage.js